export const path = {
  HOME: "/",
  APARTMENTS: "/catalog/flats",
  COTTAGES: "/catalog/cottages",
  BATHS: "/catalog/baths",
  CARS: "/catalog/cars",
};
